import { CategoryType } from '@diritto/common/content/constants';
import { EditButton } from '@/ui-components/common/EditButton';
import { FilterBox } from 'ui-components/common/FilterBox';
import { VerticalLine } from 'ui-components/common/VerticalLine';
import { FilterMenuGroup } from '@/ui-components/common/FilterItemList';
import { CategoryFilterItem } from '@/ui-components/common/CategoryFilterItemList';
import { CategoryFilterBox } from '@/ui-components/common/CategoryFilterBox';

interface ContentOrderTabProps {
  categoryItems: CategoryFilterItem[];
  filterMenuGroups: FilterMenuGroup[];
  categoryType: CategoryType;
  sectionText?: string;
  itemCount?: number;
  isEditing: boolean;
  isFiltering?: boolean;
  onEditClick: () => void;
}

export const ContentOrderTab = ({
  categoryItems,
  filterMenuGroups,
  categoryType,
  sectionText = '작품',
  itemCount,
  isEditing,
  isFiltering = false,
  onEditClick,
}: ContentOrderTabProps) => (
  <div className="flex flex-row items-center justify-between p-4">
    <div className="flex flex-row items-center space-x-1">
      <p className="text-xxs font-bold">{sectionText}</p>
      <p className="text-xxs font-normal">{itemCount}</p>
    </div>
    <div className="flex flex-row items-center justify-center space-x-4">
      <div className="flex flex-row items-center space-x-2">
        <CategoryFilterBox items={categoryItems} categoryType={categoryType} />
        <VerticalLine height={12} />
        <FilterBox filterMenuGroups={filterMenuGroups} isFiltering={isFiltering} />
      </div>
      <EditButton onClick={onEditClick} disabled={!isEditing}>
        편집
      </EditButton>
    </div>
  </div>
);
